import script from "./EventVideoList.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventVideoList.vue?vue&type=script&setup=true&lang=ts"

import "./EventVideoList.vue?vue&type=style&index=0&id=5dc33de5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dc33de5"]])

export default __exports__